import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Organization } from '../components/organization/org';
import { OrgList, OrgQuery } from '../components/organization/org-list';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  getQueryParams(filter: OrgQuery): HttpParams {
    return new HttpParams({ fromObject: filter })
  }

  getOrganizationForUser():Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });   
    return  this.http.get(this.apiUrl+'organization/getOrgsForUser',{headers:headers});
  }

  createOrg(org: Organization): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    const { id, ...payload } = org;
    const body = id ? org : payload;
    return this.http.post(this.apiUrl + 'organization/createOrg', body, { headers });
  }

  getOrgDetailsForView(id: string): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('orgId', id);
    return this.http.get(this.apiUrl + 'organization/getOrgDetailsForView', { headers, params });
  }

  getAllOrgs(queryFilter:OrgQuery):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = this.getQueryParams(queryFilter);
    return this.http.get<OrgList[]>(this.apiUrl+'organization/getAllOrgs',{headers:headers,params:params,observe:'response'});

  }

  getOrgDetailsForUpdate(id: string): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('orgId', id);
    return this.http.get(this.apiUrl + 'organization/getOrgDetailsForUpdate', { headers, params });
  }

  updateOrg(org:Organization):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post(this.apiUrl + 'organization/updateOrg', org, { headers: headers });
  }

  deleteOrg(id: string): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.delete(this.apiUrl + 'organization/deleteOrg', { headers, params });
  }

  getOrgAuditLogs(id: string): Observable<any> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('orgId', id);
    return this.http.get(this.apiUrl + 'organization/getOrgAuditLogs', { headers, params });
  }

}
